<div class="account-section">
  <div class="my-section-box">
    @if (tableData) {
      <form [formGroup]="endurasureSummaryForm">
        <div class="my-section-box__headline">
        {{ 'common.smartire_savings' | cxTranslate }}</div>
        <div class="my-section-box endurasureSummary" id="endurasureSummary">
          <div class="my-section-box-inner fleet-info-block">
            <div class="enduraSuretable-css">
              <table class="EnduraSureTable">
                <tbody>
                  <tr>
                    <th>{{"common.text_smartire_xyz_trucking_co" | cxTranslate}}</th>
                    <th>{{"common.text_smartire_normal" | cxTranslate}}</th>
                    <th>{{"common.text_smartire_header" | cxTranslate}}</th>
                    <th class="line">{{"common.text_smartire_saving" | cxTranslate}}</th>
                  </tr>
                  <tr>
                    <td>{{"common.smartire_Annual_Tire_Costs" | cxTranslate}}</td>
                    <td id="res1_norm">{{(tableData[0]?.res1_norm)}}</td>
                    <td id="res1_smar">{{ (tableData[0]?.res1_smar)}}</td>
                    <td id="res1_save" class="line"> {{ (tableData[0]?.res1_save)
                    }}</td>
                  </tr>
                  <tr>
                    <td>{{"common.smartire_Annual_Fuel_Costs" | cxTranslate}}</td>
                    <td id="res2_norm"> {{ (tableData[1]?.res2_norm)}}</td>
                    <td id="res2_smar">{{ (tableData[1]?.res2_smar) }}</td>
                    <td id="res2_save" class="line">{{(tableData[1]?.res2_save) }}
                    </td>
                  </tr>
                  <tr>
                    <td>{{"common.smartire_Annual_Tire_Maintenance" | cxTranslate}}</td>
                    <td id="res3_norm">{{ (tableData[2]?.res3_norm) }}</td>
                    <td id="res3_smar">&nbsp;{{ (tableData[2]?.res3_smar) }}</td>
                    <td id="res3_save" class="line">{{ (tableData[2]?.res3_save) }}
                    </td>
                  </tr>
                  <tr>
                    <td>{{"common.smartire_Downtime" | cxTranslate}}</td>
                    <td id="res4_norm">{{ (tableData[3]?.res4_norm) }}</td>
                    <td id="res4_smar">{{ (tableData[3]?.res4_smar) }}</td>
                    <td id="res4_save" class="line">{{ (tableData[3]?.res4_save)}}
                    </td>
                  </tr>
                  <tr>
                    <td><strong>{{"common.smartire_total" | cxTranslate}}</strong></td>
                    <td id="tot_norm"><strong>{{ (tableData[4]?.tot_norm)
                    }}</strong></td>
                    <td id="tot_smar"><strong>{{ (tableData[4]?.tot_smar)
                    }}</strong></td>
                    <td id="tot_save" class="line"><strong>{{
                    (tableData[4]?.tot_save)}}</strong></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <br>
              <div class="enduraSuretable2-css">
                <table class="ROITable">
                  <tbody>
                    <tr>
                      <th colspan="2">{{ 'common.smartire_roi' | cxTranslate }}</th>
                    </tr>
                    <tr class="ui-weight">
                      <td class="roi_left">{{ 'common.smartire_Annual_Savings' | cxTranslate }}</td>
                      <td id="tot_anual" class="line">{{ (tableData[5]?.tot_anual)}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <br>
                <h3 class="roi-h3">{{"common.text_smartire_calculate_following" | cxTranslate}}</h3>
                <div class="list roi-val-list">
                  <p>{{"common.text_smartire_reduce_tire_thread" | cxTranslate}}</p>
                  <p>{{"common.text_smartire_reduce_fuel_economy" | cxTranslate}} </p>
                  <p>{{"common.text_smartire_tire_failure" | cxTranslate}} </p>
                  <p>{{"common.text_smartire_tire_related" | cxTranslate}} </p>
                  <p>{{"common.text_smartire_smartwave_tpms" | cxTranslate}}<input type="text"
                  formControlName="roiReduce" id="roi_reduce" class="smallT" value="40" />%</p>
                </div>
                <div class="airdisk-button-block endasure-button-block">
                  <button type="button" class="btn btn-primary endaSureBack  yellow-btn"
                    (click)="endaSureBack()"><img src="/icons/link-right-white.svg" class="right-arrow"
                    alt="">
                  {{ 'common.value_calculator_back_button' | cxTranslate }}</button>
                  <mat-dialog-actions>
                    <button type="button" class="btn btn-primary EmailResults yellow-btn"
                      (click)="emailPopup()">{{ 'common.value_calculator_email_results' | cxTranslate }}
                      <img src="/icons/link-right-white.svg" class="right-arrow" alt=""></button>
                    </mat-dialog-actions>
                    <button type="button" class="btn btn-primary endaSureRest  yellow-btn"
                      (click)="resetForms()">{{ 'common.value_calculator_reset_text' | cxTranslate }}
                      <img src="/icons/link-right-white.svg" class="right-arrow" alt=""></button>
                    </div>
                  </div>
                </div>
              </form>
            }
          </div>
        </div>